<template>
    <about />
</template>
<script>

    import about from '@/components/About'
    export default {
        name: 'about-view',
        components: {
            about
        }
    }
</script>
